import React from 'react';
import ReactDOM from "react-dom";
import { Element, scroller } from 'react-scroll';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from 'react-share';

import conversionTracker from '@utils/conversionTracker';
import { SpinIcon } from '../../components/SpinIcon';
import CopyToClipboard from 'react-copy-to-clipboard';
import isValidEmail from '@utils/isValidEmail';
import { safeCredentials, handleErrors } from '@utils/fetchHelpers';

import './FreebiePage.scss';

class FreebiePage extends React.Component {
  state = {
    email: '',
    firstName: '',
    success: false,
    emailError: false,
    firstNameError: false,
    submitting: false,
    error: false,
    copied: false,
  }

  onCopiedLink = () => {
    this.setState({ copied: true }, () => {
      setTimeout(() => { this.setState({ copied: false }); }, 1000);
    });
  }

  submitRequest = (e) => {
    e.preventDefault();
    this.setState({ error: false, emailError: false, firstNameError: false, submitting: true, noSelectionError: false }, () => {
      scroller.scrollTo('submittingContainer', {
        offset: -60,
      });
    });

    if (!isValidEmail(this.state.email)) {
      this.setState({ emailError: true, submitting: false });
    } else if (this.state.firstName.trim() === '') {
      this.setState({ firstNameError: true, submitting: false });
    } else {
      conversionTracker(window, 'Lead', {
        email: this.state.email,
        first_name: this.state.firstName,
        content_category: 'freebies',
        content_name: this.props.server_data.params.long_symbol,
      });

      fetch(`/api/v2/courses/${this.props.server_data.params.long_symbol}/request_enrollment`, safeCredentials({
        method: 'POST',
        body: JSON.stringify({
          first_name: this.state.firstName,
          email: this.state.email,
          course_long_symbol: this.props.server_data.params.long_symbol,
        }),
      }))
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((responseArray) => {
        if (responseArray.success) {
          this.setState({ submitting: false, success: true }, () => {
            scroller.scrollTo('successContainer', {
              offset: -60,
            });
          });
        }
        if (responseArray.created) {
          this.props.history.replace('/classroom');
        }
      })
      .catch((error) => {
        this.setState({ submitting: false, error: true });
        console.error(error);
      });
    }
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    const course = this.props.server_data.course.data;

    return ReactDOM.createPortal(
      <React.Fragment>
        { !this.state.success && !this.state.submitting && (
          <form onSubmit={this.submitRequest} className='d-flex flex-column flex-md-row form'>
            <div className='d-none d-md-flex subItemsContainer'>
              <div className='d-flex flex-column align-items-start summaryBox'>
                <p className='title'>Enroll in {course.attributes.long_name}</p>
                <div className='d-flex align-items-start flex-column'>
                  <img src={`https://cdn.altcademy.com/assets/images/medium/freebies/${this.props.server_data.params.long_symbol}.jpg`} className='img-fluid' />
                </div>
              </div>
            </div>
            <div className='textFields'>
              <div className="form-group">
                <label htmlFor="freebie_form_first_name">First Name</label>
                <input
                  name="firstName"
                  type="text"
                  value={this.state.firstName}
                  onChange={this.handleChange}
                  className='textField text-capitalize form-control'
                  disabled={this.state.submitting}
                  id="freebie_form_first_name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="freebie_form_email">Email Address</label>
                <input
                  name="email"
                  type="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  className='textField form-control'
                  disabled={this.state.submitting}
                  id="freebie_form_email"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={this.state.submitting}
                className="btn btn-primary normalButton altButton text-uppercase btn-block"
                style={{fontSize: '1em', fontWeight: '500'}}
              >
                Enroll
              </button>

              {this.state.noSelectionError && <p className='errorMessage'><small>Please select at least one item.</small></p>}
              {this.state.error && <p className='errorMessage'><small>Could not submit request. Please make sure you've enabled cookies. If you want to talk to a human, <a href="mailto: hello@altcademy.com">email us now</a>.</small></p>}
              <p className='d-none text-center'>
                <small><em>By providing us with your email, you agree to the terms of our <a href="/legal/privacy" target="_blank">Privacy Policy</a> and <a href="/legal/terms" target="_blank">Terms of Service</a>.</em></small>
              </p>
            </div>
          </form>
        )}

        { this.state.success && (
          <Element name="successContainer" className='d-flex flex-column align-items-center successContainer'>
            <div className='rounded message'>
              <h3>Check Your Inbox.</h3>

              <p><b>Check your inbox now</b>. You will receive 2 emails: a welcome email & an email to access Altcademy Classroom.</p>

              <p>If you <b>can't find the emails</b>, please check your <b>Spam inbox</b>, and <b>mark us as non-spam</b>.</p>
            </div>

            <p>Share this Freebie with your friends<br />by sending them the following link.</p>
            <div className="d-flex flex-column flex-sm-row align-items-center" style={{ marginBottom: '8px' }}>
              <p className='courseLink'>{`https://www.altcademy.com/freebies/${course.attributes.long_symbol}`}</p>
              <CopyToClipboard
                text={`https://www.altcademy.com/freebies/${course.attributes.long_symbol}`}
                onCopy={() => this.onCopiedLink()}
              >
                <button
                  type="submit"
                  disabled={this.state.submitting}
                  className="btn btn-primary altButton text-uppercase"
                  style={{fontSize: '1em', fontWeight: '500'}}
                >
                  {this.state.copied ? 'Copied' : 'Copy'}
                </button>
              </CopyToClipboard>
            </div>

            <div className="d-flex flex-row justify-content-center">
              <FacebookShareButton url={`https://www.altcademy.com/freebies/${course.attributes.long_symbol}`} quote={course.attributes.description} picture={`https://cdn.altcademy.com/assets/images/medium/freebies/${this.props.server_data.params.long_symbol}.jpg`} className='social'>
                <FacebookIcon size={32} round className='scIcon' />
              </FacebookShareButton>

              <TwitterShareButton url={`https://www.altcademy.com/freebies/${course.attributes.long_symbol}`} title={course.attributes.long_name} via="altcademy" picture={`https://cdn.altcademy.com/assets/images/medium/freebies/${this.props.server_data.params.long_symbol}.jpg`} className='social'>
                <TwitterIcon size={32} round className='scIcon' />
              </TwitterShareButton>

              <LinkedinShareButton url={`https://www.altcademy.com/freebies/${course.attributes.long_symbol}`} title={course.attributes.long_name} description={course.attributes.description} className='social'>
                <LinkedinIcon size={32} round className='scIcon' />
              </LinkedinShareButton>
            </div>
          </Element>
        )}

        { this.state.submitting && (
          <Element name="submittingContainer" className='submittingContainer d-flex flex-column justify-content-center align-items-center'>
            <SpinIcon />
          </Element>
        ) }
      </React.Fragment>,
    document.getElementById("signup_form_portal"));
  }
}

export default FreebiePage;
